import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import useFetchWrapper from '../../Helpers/useFetchWrapper';
import { usePopupContext } from '../../Helpers/PopupProvider';

import {
	CreateRatingRequest,
	FormData,
	Props,
} from './RatingPopup.model';
import { Rating, Score } from '../../Helpers/useScoreHelper';

const useCreateResource = ({ userId }: Props) => {
	const [ activeStep, setActiveStep ] = useState(-1);
	const [ score, setScore ] = useState<Score>(Score.Good);

	const defaultValues: any = {
		feedback: '',
		score: 2,
	};

	const {
		clearErrors,
		control,
		formState: { errors },
		handleSubmit,
		trigger,
		watch
	} = useForm({ defaultValues });
	const { post } = useFetchWrapper();
	const { onPopupClose, onPopupOpen } = usePopupContext();
	
	const watchScore = watch('score');

	useEffect(() => {
		onPopupOpen();
		watchScore && setScore(getScoreLabel(watchScore))
	}, [ watchScore ])

	const getScoreLabel = (score: number): Score => {
		switch(score) {
			case 1:
				return Score.Substandard;
			case 2:
				return Score.Good;
			case 3:
				return Score.Exceptional;
			default:
				return Score.Good;
		}
	}

	const handleStepBack = () => {
		clearErrors();
		setActiveStep((currentValue) => currentValue - 1);
	}

	const handleStepSubmit = async () => {
		let validEmail: boolean = true;

		switch (activeStep) {
			case 1:
				await trigger(['score']);
				break;
			case 2:
				await trigger(['feedback']);
				break;
		}

		if (Object.keys(errors).length || !validEmail) {
			return;
		} else {
			setActiveStep((currentValue) => currentValue + 1)
		}
	}

	const onSubmit = async (data: FormData) => {
		const { feedback, score } = data;
		const scores: Rating[] = ['One', 'Four', 'Five'];

		const body: CreateRatingRequest = {
			feedback,
			ratedUserId: userId,
			score: scores[parseInt(score) - 1],
		}

		await post(`/review/rating`, body);
		setActiveStep((currentValue) => currentValue + 1)
	}

	return {
		control,
		errors,
		handleStepBack,
		handleStepSubmit,
		handleSubmit,
		onPopupClose,
		onSubmit,
		state: { activeStep, score },
	}
}

export default useCreateResource;